import { ArrowUpRight } from "lucide-react";
import Placeholder from "./Placeholder";
import StatusBadge from "./StatusBadge";
import { useI18n } from "../lib/i18n";

export default function ProjectCard({ project, onOpen, index = 0 }) {
  const { t } = useI18n();
  return (
    <div
      data-testid={`project-card-${project.id}`}
      onClick={() => onOpen(project)}
      className="group cursor-pointer bg-[#0A0A0A] border border-white/10 rounded-2xl p-6 flex flex-col nh-fade-up transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-1 hover:border-nhgreen/50 hover:shadow-[0_0_24px_rgba(34,255,119,0.18)]"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      {project.logo ? (
        <div className="h-[200px] flex items-center justify-center rounded-xl bg-white/[0.03] border border-white/5 p-1">
          <img
            src={project.logo}
            alt={project.title}
            className="max-h-full max-w-full object-contain"
            loading="lazy"
          />
        </div>
      ) : (
        <Placeholder label={project.title.split(" ")[0]} minH="h-[200px]" />
      )}
      <div className="flex items-start justify-between gap-3 mt-5">
        <h3 className="font-mono font-bold text-lg text-white leading-tight group-hover:text-nhgreen transition-colors duration-200">
          {project.title}
        </h3>
        <ArrowUpRight className="shrink-0 w-5 h-5 text-white/30 group-hover:text-nhgreen transition-colors duration-200" />
      </div>
      <p className="text-sm text-white/60 leading-relaxed mt-3 flex-1">{project.tagline}</p>
      <div className="mt-5 flex items-center justify-between">
        <StatusBadge status={project.status} />
        <span className="font-mono text-[11px] text-white/40 group-hover:text-nhgreen transition-colors duration-200">
          {t("read_more")} →
        </span>
      </div>
    </div>
  );
}
